import { lang } from '@umu/ukit-lang';
import './pricingTitle.scss';
import React from 'react';
import { IProps } from '@umu/umu-types';
import { If, PreImg } from 'common/src/components';

export const PricingTitle = (props: IProps) => {
    const { isRegisterUser, platform } = props;
    return (
        <>
            <If condition={platform === 'mobile'}>
                <PreImg>
                    <img className="pricing-m-bg" src={require(`../../images/pricing-m-bg.png`)} alt="" />
                </PreImg>
            </If>
            <If condition={isRegisterUser}>
                <>
                    <If condition={platform === 'twww'}>
                        <div
                            className="pricing-title"
                            dangerouslySetInnerHTML={{
                                // tslint:disable-next-line:max-line-length
                                __html: lang('欢迎升级 UMU 服务方案'),
                            }}
                        ></div>
                    </If>
                    <If condition={platform === 'mobile'}>
                        <div className="pricing-title pricing-m-title">
                            {lang('欢迎升级')}
                            <br />
                            {lang('UMU 服务方案')}
                        </div>
                    </If>
                </>
            </If>
            <If condition={!isRegisterUser}>
                <>
                    <If condition={platform === 'twww'}>
                        <div
                            className="pricing-title"
                            dangerouslySetInnerHTML={{
                                // tslint:disable-next-line:max-line-length
                                __html: lang('选择最佳方案，开启 UMU 体验之旅'),
                            }}
                        ></div>
                    </If>
                    <If condition={platform === 'mobile'}>
                        <div className="pricing-title pricing-m-title">
                            {lang('选择最佳方案')}
                            <br />
                            {lang('开启UMU体验之旅')}
                        </div>
                    </If>
                </>
            </If>
        </>
    );
};

// console.end();
